import { formatUsOnlyDropdown } from '@/javascripts/stimulus_controllers/donations/helpers'
// Currently, default options for a single-charity US-only Select2 Search
// Used in US Off Portal Volunteering Log Modal and as starting option
// for Donation Global Giving Search and Off Portal Donation Upload
let select2Defaults = {
  escapeMarkup(markup) {
    return markup
  },
  closeOnSelect: true,
  placeholder: 'Search by charity names',
  minimumInputLength: 3,
  templateResult: formatUsOnlyDropdown,
  ajax: {
    url: '/charities/search',
    dataType: 'json',
    delay: 250,
    language: {
      inputTooShort: function () {
        return 'Please enter at least 3 or more characters'
      }
    },
    data({ term }) {
      return {
        charity_name: term,
        countries: ['US']
      }
    },
    processResults(data) {
      return {
        results: data['US'].map((charity) => {
          return {
            id: charity.id,
            text: `${charity.name} (EIN: ${charity.ein})`,
            title: 'US',
            charity: charity
          }
        })
      }
    },
    cache: true
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Select2 in modals
  $('.volunteer-log-charity-select').select2({
    ...select2Defaults,
    dropdownParent: $('#offportal-usa-volunteer-modal')
  })

  // The below pages offer a country select, but since we always load with
  // US selected as a default, we can initialize with US-centric settings from above
  // And update via stimulus controller if the user changes countries
})
